module.exports = __webpack_public_path__ + "img/logo-mini.ada0112b.svg";